import _classCallCheck from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Action } from "../../internal/Action";
import { Qualifier } from "../../internal/qualifier/Qualifier";
import { QualifierValue } from "../../internal/qualifier/QualifierValue";
/**
 * @extends SDK.Action
 * @memberOf Actions.Transcode
 * @description  Defines the video bitrate in bits per second.
 *
 * <b>Learn more</b>: {@link https://cloudinary.com/documentation/video_manipulation_and_delivery#bitrate_control | Bitrate control}
 * @see Visit {@link Actions.Transcode|Transcode} for an example
 */

var BitRateAction = /*#__PURE__*/function (_Action) {
  _inherits(BitRateAction, _Action);

  var _super = _createSuper(BitRateAction);

  function BitRateAction(bitRate) {
    var _this;

    _classCallCheck(this, BitRateAction);

    _this = _super.call(this);
    _this.isConstant = false;
    _this.bitRate = bitRate;
    return _this;
  }
  /**
   * @description video plays with a constant bitrate (CBR).
   */


  _createClass(BitRateAction, [{
    key: "constant",
    value: function constant() {
      this.isConstant = true;
      return this;
    }
  }, {
    key: "prepareQualifiers",
    value: function prepareQualifiers() {
      var qualifierValue;

      if (this.isConstant) {
        qualifierValue = new QualifierValue([this.bitRate, 'constant']).setDelimiter(':');
      } else {
        qualifierValue = new QualifierValue(this.bitRate);
      }

      this.addQualifier(new Qualifier('br', qualifierValue));
      return this;
    }
  }]);

  return BitRateAction;
}(Action);

export default BitRateAction;